import { Plane, Box, Bus } from "lucide-react";
import React from "react";

export function ValueAdded() {
  const features = [
    {
      icon: Plane,
      title: "Proximité Aéroport",
      description:
        "À seulement 10 minutes de l'Aéroport de Beauvais/Tillé en expansion constante",
    },
    {
      icon: Box,
      title: "Box Individuel",
      description: "Espace couvert et sécurisé pour votre véhicule",
    },
    {
      icon: Bus,
      title: "Navette 24/7",
      description:
        "Service de navette disponible à toute heure pour vous conduire à l'aéroport",
    },
  ];

  return (
    <section className="py-20 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="bg-[#0A0A0A]/80 rounded-2xl p-12 border-2 border-[#FF7954]
                      transform hover:-translate-y-2 transition-all duration-300"
        >
          <h2 className="text-4xl font-bold text-[#FF7954] text-center mb-16 relative">
            Valeur Ajoutée
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8 mb-8 sm:mb-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="p-4 sm:p-6 rounded-xl bg-[#0A0A0A]/50 border border-[#FF7954]/30
                           hover:border-[#FF7954] transition-all duration-300
                           transform hover:-translate-y-2 h-[250px] sm:h-[300px] flex flex-col"
              >
                <div
                  className="w-12 h-12 sm:w-16 sm:h-16 bg-[#FF7954] rounded-full flex items-center justify-center mb-4 sm:mb-6 mx-auto
                              transform transition-all duration-300 hover:scale-110 hover:rotate-12"
                >
                  <feature.icon size={24} className="text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-white text-center mb-3 sm:mb-4">
                  {feature.title}
                </h3>
                <p className="text-sm sm:text-base text-[#FCDEBE] text-center flex-grow">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-[#0A0A0A]/80 rounded-xl p-6 sm:p-8 border-2 border-[#FF7954] relative">
            <span className="text-4xl sm:text-6xl text-[#FF7954]/20 font-serif absolute top-4 left-6 sm:left-8">
              "
            </span>
            <p className="text-white text-sm sm:text-lg italic pl-8 sm:pl-12 pt-2 relative z-10">
              Dans une ville où l'Aéroport de Beauvais/Tillé ne fait que de
              s'agrandir, nous vous proposons un parking privé avec box
              individuel. Nous sommes disponible à toute heure pour votre
              navette en direction de l'aéroport.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
